const EXCEL_EXTENSIONS = ['xls', 'xlsx', 'xlsm', 'xlsb', 'csv']
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png']
const PDF_EXTENSIONS = ['pdf']
const JSON_EXTENSIONS = ['json']
const PPT_EXTENSIONS = ['ppt', 'pptx']

export function getRecordFileName(record) {
  return (record && (record.file_name || record.name)) || ''
}

export function hasRecordFile(record) {
  return Boolean(record && (record.file_download_url || record.file_name))
}

export function getRecordFileExt(record) {
  const fileName = getRecordFileName(record)
  const lastDotIndex = fileName.lastIndexOf('.')
  if (lastDotIndex === -1) return ''
  return fileName.slice(lastDotIndex + 1).toLowerCase()
}

export function isExcelFile(record) {
  return EXCEL_EXTENSIONS.includes(getRecordFileExt(record))
}

export function isExcelRecord(record) {
  return Boolean(record && ['file', 'common'].includes(record.category) && isExcelFile(record))
}

export function isImageFile(record) {
  return IMAGE_EXTENSIONS.includes(getRecordFileExt(record))
}

export function isPdfFile(record) {
  return PDF_EXTENSIONS.includes(getRecordFileExt(record))
}

export function isJsonFile(record) {
  return JSON_EXTENSIONS.includes(getRecordFileExt(record))
}

export function isPptFile(record) {
  return PPT_EXTENSIONS.includes(getRecordFileExt(record))
}

export function getFileTypeLabel(record) {
  if (!record) return ''
  if (isExcelFile(record)) return 'Excel'
  if (isImageFile(record)) return 'Image'
  if (isPdfFile(record)) return 'PDF'
  if (isJsonFile(record)) return 'JSON'
  if (record.category === 'rpa' || record.data_type === 'result_file') return 'RPA'
  if (record.category === 'master') return 'Table'
  if (record.category === 'file' && hasRecordFile(record)) return 'Etc'
  return 'Common'
}

export function getDataCategoryLabel(record) {
  if (!record || !record.category) return ''
  if (record.category === 'file') {
    if (isExcelFile(record)) return '엑셀 파일'
    if (isImageFile(record)) return '이미지 파일'
    if (isPdfFile(record)) return 'PDF 파일'
    if (isJsonFile(record)) return 'JSON 파일'
    return '파일'
  }
  if (record.category === 'common') return '일반'
  if (record.category === 'rpa') return '워크플로우 결과'
  if (record.category === 'text_ie') return 'PDF 분류 결과'
  return ''
}

export function getFileIconSrc(record) {
  if (!record) return '/assets/data_icon/icon_recolumn2.svg'
  if (record.category === 'rpa' || record.data_type === 'result_file') return '/assets/data_icon/icon_rpa2.svg'
  if (record.category === 'master') return '/assets/data_icon/icon_master.svg'
  if (isExcelFile(record)) {
    return record.category === 'common'
      ? '/assets/data_icon/icon_recolumn2.svg'
      : '/assets/data_icon/icon_excel.svg'
  }
  if (isImageFile(record)) return '/assets/data_icon/icon_img.svg'
  if (isPdfFile(record)) return '/assets/data_icon/icon_pdf2.svg'
  if (isPptFile(record)) return '/assets/data_icon/icon_ppt.svg'
  if (isJsonFile(record)) return '/assets/data_icon/icon_json2.svg'
  if (record.category === 'file' && hasRecordFile(record)) return '/assets/data_icon/icon_unknown.svg'
  return '/assets/data_icon/icon_recolumn2.svg'
}
